import React from 'react';
import LinkedItemsCard from './LinkedItemsCard';

/**
 * LinkedRulesets component
 * Displays a list of rulesets linked to the current family
 */
export default function LinkedRulesets({ rulesets, onSelectRuleset }) {
    const items = rulesets || [];

    return (
        <LinkedItemsCard icon="fa-solid fa-table-list" title="Rulesets" count={items.length}>
            {items.length > 0 ? (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                    {items.map(rs => (
                        <button
                            key={rs.id}
                            type="button"
                            className="linked-item-row clickable-row"
                            onClick={() => onSelectRuleset?.(rs)}
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '0.5rem 0.75rem',
                                border: '1px solid var(--border)',
                                fontSize: '0.85rem',
                                width: '100%',
                                fontFamily: 'inherit',
                                textAlign: 'left',
                                gap: '0.75rem'
                            }}
                        >
                            <span className="row-title" style={{ fontFamily: 'monospace' }}>{rs.name}</span>
                            <span className="row-muted" style={{ fontSize: '0.75rem' }}>
                                {rs.rowCount ?? rs.rows?.length ?? 0} rows
                            </span>
                        </button>
                    ))}
                </div>
            ) : (
                <p style={{
                    fontStyle: 'italic',
                    color: 'var(--text-secondary)',
                    fontSize: '0.85rem',
                    margin: 0
                }}>
                    No rulesets currently assigned.
                </p>
            )}
        </LinkedItemsCard>
    );
}
